
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import EventsCalendar from '@/components/EventsCalendar.vue';

@Options({
  components: { EventsCalendar },
  computed: {
    ...mapGetters(['getJsonData']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    }
  }
})
export default class News extends Vue {}
